import { inject, Injectable } from '@angular/core';
import {
  SRM_TICKET_CREATE_ROUTE_PATH,
  SRM_TICKET_OVERVIEW_ROUTE_PATH,
} from '@libs/shared/models';
import { CMS_PAGE_ROUTE_CONTEXT, CmsPageRouteContext } from '../cms-page-route-context';

@Injectable({ providedIn: 'root' })
export class SrmNavigationService {
  private readonly routeContext: CmsPageRouteContext | null = inject(CMS_PAGE_ROUTE_CONTEXT, { optional: true });

  public overviewPath(): string {
    return this.routeContext?.basePath ?? SRM_TICKET_OVERVIEW_ROUTE_PATH;
  }

  public createLink(): string {
    return this.routeContext
      ? `${this.routeContext.basePath}/create`
      : `/${SRM_TICKET_CREATE_ROUTE_PATH}`;
  }

  public ticketLink(ticketIdentifier: string): string {
    const encodedTicketIdentifier: string = encodeURIComponent(ticketIdentifier);

    return this.routeContext
      ? `${this.routeContext.basePath}/${encodedTicketIdentifier}`
      : `/${SRM_TICKET_OVERVIEW_ROUTE_PATH}/${encodedTicketIdentifier}`;
  }
}
